export const registerCommissionOverridePolicies = (Alpine) => {
    Alpine.data('commissionOverridePolicies', (initial = {}) => ({
        poolPolicy: initial.poolPolicy ?? 'all',
        globalPolicy: initial.globalPolicy ?? 'all',
        shouldShowPoolSelections() {
            return this.poolPolicy === 'only_selected';
        },
        shouldShowGlobalSelections() {
            return this.globalPolicy === 'only_selected';
        },
    }));
};
